


const placeholders=[

    { 
        title:"e.g. Organize a team meeting",
        body:"e.g. This task involves coordinating and scheduling a meeting with team members to discuss project progress, goals, and any issues or concerns. It may also involve creating an agenda, sending out reminders, and documenting the meeting outcomes."
    },
    { 
        title:"e.g. Review and analyze financial reports",
        body:"e.g. This task involves reviewing financial data and reports, such as income statements, balance sheets, and cash flow statements. It may also involve analyzing trends, identifying areas for improvement, and making recommendations for financial strategies."
    },
    { 
        title:"e.g. Create a product roadmap",
        body:"e.g. This task involves creating a plan or timeline for the development of a new product, including setting goals, outlining the steps involved, and estimating timelines for each stage."
    },
    { 
        title:"e.g. Write a business proposal",
        body:"e.g. This task involves creating a formal document that outlines a proposed business idea or project. It should include information on the business concept, target market, competition, marketing strategy, financial projections, and any other relevant details."
    },
    { 
        title:"e.g. Create a social media campaign",
        body:"e.g. This task involves developing and executing a marketing campaign on social media platforms like Facebook, Instagram, or Twitter. This may involve creating content, identifying target audiences, monitoring engagement, and measuring results."
    },
    { 
        title:"e.g. Design a website mockup",
        body:"e.g. This task involves creating a visual representation of a website's layout and design, often using tools like wireframes or mockup software. It may also involve incorporating branding elements, color schemes, and other design considerations."
    },{ 
        title:"e.g. Develop a Marketing Strategy",
        body:"e.g.  This task involves creating a comprehensive marketing plan that includes tactics such as social media, email marketing, and advertising to reach and engage your target audience."
    },
    { 
        title:"e.g. Implement Agile Methodology",
        body:"e.g. This task involves introducing Agile methodologies to software development teams, including practices like Scrum and Kanban, to increase productivity and efficiency."
    },
    { 
        title:"e.g. Conduct User Testing",
        body:"e.g. This task involves gathering feedback from actual users on your product or service to identify areas for improvement and refine the user experience."
    },
    { 
        title:"e.g. Improve Website Performance",
        body:"e.g. This task involves identifying and addressing issues with website speed, user experience, and search engine optimization to improve overall website performance."
    },
    { 
        title:"e.g. Create a Data Management Strategy",
        body:"e.g. This task involves developing a comprehensive plan for managing and organizing data across different departments to improve data accuracy, accessibility, and security."
    },
    { 
        title:"e.g. Conduct Employee Training",
        body:"e.g. This task involves creating and delivering training programs for employees to develop their skills and knowledge, improve job performance, and increase employee satisfaction."
    }
]



export default placeholders